module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.currentlyVisible,
      "title": "Create Spot Survey",
      "before-close": _vm.handleCancel
    },
    on: {
      "update:visible": function($event) {
        _vm.currentlyVisible = $event
      }
    }
  }, [_c('p', [_vm._v("Create a new spot survey by asking questions, and providing the possible choices a user can select from")]), _vm._v(" "), _c('el-form', {
    ref: "surveyForm",
    attrs: {
      "label-width": "120px",
      "model": _vm.surveyForm,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Survey title",
      "prop": "title"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.surveyForm.title),
      callback: function($$v) {
        _vm.$set(_vm.surveyForm, "title", $$v)
      },
      expression: "surveyForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Campaign",
      "prop": "campaignId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.surveyForm.campaignId),
      callback: function($$v) {
        _vm.$set(_vm.surveyForm, "campaignId", $$v)
      },
      expression: "surveyForm.campaignId"
    }
  }, _vm._l((_vm.activeCampaigns), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.title,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Start date",
      "prop": "startDate"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.surveyForm.startDate),
      callback: function($$v) {
        _vm.$set(_vm.surveyForm, "startDate", $$v)
      },
      expression: "surveyForm.startDate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('el-form-item', {
    attrs: {
      "label": "End date",
      "prop": "endDate"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.surveyForm.endDate),
      callback: function($$v) {
        _vm.$set(_vm.surveyForm, "endDate", $$v)
      },
      expression: "surveyForm.endDate"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Redirect URL",
      "prop": "redirectUrl"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "https://"
    },
    model: {
      value: (_vm.surveyForm.redirectUrl),
      callback: function($$v) {
        _vm.$set(_vm.surveyForm, "redirectUrl", $$v)
      },
      expression: "surveyForm.redirectUrl"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "help-text"
  }, [_vm._v("After the listener has completed the survey successfully, where do we want to redirect them?")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Logo URL",
      "prop": "logoUrl"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "https://"
    },
    model: {
      value: (_vm.surveyForm.logoUrl),
      callback: function($$v) {
        _vm.$set(_vm.surveyForm, "logoUrl", $$v)
      },
      expression: "surveyForm.logoUrl"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "help-text"
  }, [_vm._v("Display this logo image on the spot survey form presented to the listener.")])], 1), _vm._v(" "), _vm._l((_vm.surveyForm.questions), function(question, index) {
    return _c('div', {
      key: question.id,
      staticClass: "question-block"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Question",
        "prop": ("questions." + index + ".title"),
        "rules": {
          required: true,
          message: 'Please provide a question',
          trigger: 'blur'
        }
      }
    }, [_c('el-input', {
      attrs: {
        "type": "textarea"
      },
      model: {
        value: (question.title),
        callback: function($$v) {
          _vm.$set(question, "title", $$v)
        },
        expression: "question.title"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-6"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Choice"
      }
    }, [_c('el-input', {
      model: {
        value: (question.newChoice),
        callback: function($$v) {
          _vm.$set(question, "newChoice", $$v)
        },
        expression: "question.newChoice"
      }
    }), _vm._v(" "), _c('el-button', {
      staticClass: "add-btn pull-right",
      attrs: {
        "type": "info",
        "size": "mini",
        "round": ""
      },
      on: {
        "click": function($event) {
          return _vm.handleAddChoice(question, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-plus"
    }), _vm._v(" Add choice\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "col-lg-6"
    }, [(question.choices.length === 0) ? _c('div', {
      staticClass: "el-form-item__error"
    }, [_c('em', [_vm._v("No choices have been added for this question yet!")])]) : _vm._e(), _vm._v(" "), _c('ul', {
      staticClass: "todo-list choices"
    }, _vm._l((question.choices), function(choice, choiceIndex) {
      return _c('li', {
        key: choice.id
      }, [_vm._v("\n              " + _vm._s(choice.title) + "\n              "), _c('span', {
        staticClass: "pull-right"
      }, [_c('a', {
        on: {
          "click": function($event) {
            return _vm.handleRemoveChoice(index, choiceIndex)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-fw fa-trash"
      })])])])
    }), 0)])]), _vm._v(" "), (_vm.surveyForm.questions.length < 2) ? _c('el-button', {
      staticClass: "add-btn pull-right",
      attrs: {
        "type": "success",
        "size": "mini",
        "round": ""
      },
      on: {
        "click": _vm.handleAddQuestion
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-plus"
    }), _vm._v("Add another question\n      ")]) : _vm._e(), _vm._v(" "), (index > 0) ? _c('el-button', {
      staticClass: "add-btn pull-right",
      attrs: {
        "type": "danger",
        "size": "mini",
        "round": ""
      },
      on: {
        "click": function($event) {
          return _vm.handleRemoveQuestion(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-trash"
    }), _vm._v("Remove question\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "question-block"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Profiles"
    }
  }, [_c('el-transfer', {
    attrs: {
      "data": _vm.demographicsTransfer,
      "titles": ['Available', 'Enabled'],
      "button-texts": ['Disable', 'Enable']
    },
    model: {
      value: (_vm.surveyForm.profiles),
      callback: function($$v) {
        _vm.$set(_vm.surveyForm, "profiles", $$v)
      },
      expression: "surveyForm.profiles"
    }
  })], 1)], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('p', [_c('strong', [_vm._v("Note:")]), _vm._v(" Due to the way we currently process survey data,\n      once you click\n      "), _c('em', [_vm._v("Create")]), _vm._v(", you will not be able to modify this spot survey again.\n      Please ensure that all information is correct before proceeding.\n    ")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleCreateSpotSurvey
    }
  }, [_vm._v("Create")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-707ed2b8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveys/SpotSurveyCreateDialog.vue
// module id = 3330
// module chunks = 3